import { PropsWithChildren } from 'react';
import { EventNotificationsEventIdProvider } from '../../event-notifications/event-notifications-event-id-context';

export function FrEventProviders({ children, eventId }: PropsWithChildren<{ eventId?: number }>) {
    return (
        <EventNotificationsEventIdProvider eventId={eventId}>
            {children}
        </EventNotificationsEventIdProvider>
    );
}
